import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import Button from './Button';
import Icon from './Icon';
import { formatClassName, pickDataAttributes } from '../Util';
import { Slugify } from '../util/StringUtil';
import i18n from '../../src/i18n/translate';
import { copyText } from '../util/CopyUtil';
import { displaySuccessMessage, displayErrorMessage } from '../actions/messagesActions';
import { kebabCase } from 'lodash';

const IconCategoryValue = props => {
  const {
    category, className, color, copyValue, editAction, icon, iconProps,
    tooltip, tooltipPlacement, type, value, dataAttributesForEdit, url
  } = props;

  const dataAtrName = value ? `${kebabCase(value)}-icon-category-value` : 'icon-category-value';
  const dataAttributes = pickDataAttributes(props, dataAtrName);

  const copyToClipboard = value => {
    const success = copyText(value);
    if (success) {
      displaySuccessMessage(i18n.t("Copied!"));
    } else {
      displayErrorMessage(i18n.t("Unable to copy"));
    }
  }

  const buttonElements = (
    <>
      {copyValue && (
        <Button
          className="m-l-5"
          icon="copy"
          onClick={() => copyToClipboard(copyValue)}
          style="link"
        />
      )}
      {tooltip && (
        <OverlayTrigger
          placement={tooltipPlacement}
          trigger={["hover", "focus"]}
          overlay={(
            <Popover id={`tooltip-${Slugify(category || value)}`}>
              {tooltip}
            </Popover>
          )}>
          <Button
            className="info"
            style="link"
            icon="info-outline" />
        </OverlayTrigger>
      )}
      {editAction && (
        <Button
          {...dataAttributesForEdit}
          className="edit"
          style="link"
          icon="edit"
          label={i18n.t('Edit')}
          onClick={editAction} />
      )}
    </>
  );
  return (
    <div
      {...dataAttributes}
      className={formatClassName(['icon-category-value', `${type}-icon-category-value`, `${color}-icon-category-value`, className])}
    >
      {icon && <Icon {...iconProps} additionalClasses="icon" iconType={icon} />}
      <span className="category-value">
        {category && <span className={formatClassName(['category', `${type}-category`])}>{category}</span>}
        {type === 'stacked' && buttonElements}
        {
          <span className={formatClassName(['value', `${type}-value`])}>{
            url ? <a href={url}>{value ? value : url}</a> :
              Array.isArray(value) ? value.join(', ') : value}{type === 'inline' && buttonElements}
          </span>
        }
      </span>
    </div>
  );
};

IconCategoryValue.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(['default', 'green', 'teal', 'red', 'yellow', 'blue']),
  copyValue: PropTypes.string,
  dataAttributesForEdit: PropTypes.object,
  editAction: PropTypes.func,
  icon: PropTypes.string,
  iconProps: PropTypes.object,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  type: PropTypes.oneOf(['inline', 'stacked']),
  url: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.node
  ])
};

IconCategoryValue.defaultProps = {
  color: 'default',
  dataAttributesForEdit: {},
  type: 'inline',
  tooltipPlacement: 'right'
};

export default IconCategoryValue;
